<!-- container header -->
<template>
  <div class="header">
    <el-row type="flex" align="middle">
      <el-col :span="4">
        <div class="header__logo">
          <p class="font_extralarge font_lineheight_normal">党校微课堂</p>
        </div>
      </el-col>

      <el-divider direction="vertical"></el-divider>

      <el-col :span="16">
        <div class="header__quickentry">
          <div class="block" @click="go('/')">
            <i class="el-icon-odometer"></i>
            <p class="font_medium">首页</p>
          </div>

          <div class="block" @click="clickDownload">
            <i class="el-icon-notebook-2"></i>
            <p class="font_medium">使用指南</p>
          </div>

          <!-- 打开  -->
          <!-- <template v-if="1">
            <div class="block" @click="linkApi">
              <i class="el-icon-notebook-2"></i>
              <p class="font_medium">API</p>
            </div>
          </template> -->
          
        </div>
      </el-col>

      <!-- <el-divider direction="vertical"></el-divider> -->

      <el-col :span="3">
        <div class="header__tool">
          <!-- <i class="el-icon-message"></i> -->
        </div>
      </el-col>

      <el-divider direction="vertical"></el-divider>

      <el-col :span="2" class="header__account__col">
        <div class="header__account">
          <el-dropdown>
            <span class="el-dropdown-link">
              <el-avatar shape="square" :size="50" :src="avatarUrl"></el-avatar>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div class="header__account__dropdown_item">
                <p class="header__account__dropdown__message">欢迎， {{username}}</p>
              </div>
              <div class="header__account__dropdown_item" title="所属组织" v-if="partyorgname">
                <i class="el-icon-office-building"></i>
                <p class="header__account__dropdown__company">{{partyorgname}}</p>
              </div> 
              <div class="header__account__dropdown_item" title="所属公司" v-if="companyname">
                <i class="el-icon-office-building"></i>
                <p class="header__account__dropdown__company">{{companyname}}</p>
              </div> 
              <div class="header__account__dropdown_item" title="当前权限">
                <i class="el-icon-key"></i>
                <p class="header__account__dropdown__role">{{roleNameStr}}</p>
              </div>

              <el-dropdown-item>
                <div @click="goEditProfile">
                  <i class="el-icon-setting"></i>编辑个人资料
                </div>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <div class="header__account__dropdown_item" @click="logout">
                  <i class="el-icon-switch-button"></i>退出系统
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: "AppHeader",
  
  data() {
    return {
      avatarUrl: require('@/assets/img/default_handsome.jpg'),
      company: "",
      id: "",
      loading: false
    };
  },
  
  computed: {
    // 映射Vuex状态和getters
    ...mapState('profileModule', {
      profileState: state => state
    }),
    ...mapGetters('profileModule', [
      'username',
      'rolename',
      'isadmin',
      'companyname',
      'partyorgname'
    ]),
    
    // 计算属性
    roleNameStr() {
      let rn = this.rolename;
      let adminStr = this.isadmin ? "系统管理员" : '';
      return rn || adminStr;
    }
  },
  
  methods: {
    // 映射Vuex actions
    ...mapActions('profileModule', ['LogOut']),
    
    init() {
      // 初始化逻辑
    },
    
    clickDownload() {
      const link = "https://www.yuque.com/docs/share/77b0301d-df74-4404-9136-a33a5d1fba03?# 《使用指南》";
      
      setTimeout(() => {
        window.open(link, "_blank");
      }, 2000);
    },
    
    go(href) {
      this.$router.push(href);
    },
    
    // 跳转编辑资料页面
    goEditProfile() {
      this.$router.push({
        path: '/editProfile',
        query: {
          id: this.profileState.id
        }
      });
    },
    
    logout() {
      this.LogOut()
        .then(() => {
          this.$router.push("/pages/login");
          this.$message({
            message: "登出成功!",
            type: "success"
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
    linkApi() {
      if (this.$route.meta) {
        console.log("link api");
        console.log(this.$route.meta.api);
        let api = this.$route.meta.api;
        if (api) {
          window.open(api, "_blank");
        } else {
          this.$message({
            message: "暂缺!",
            type: "error"
          });
        }
      }
    }
  },
  
  created() {
    this.init();
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
